module.exports = __webpack_public_path__ + "img/question-circle.66d8e5a0.svg";